<script>
    import ComparisonTable from './comparison-table';

    export default {
        extends: ComparisonTable,
        methods: {}
    }
</script>
